import { TaskCommentObject } from './tasks-details-comments/task-comment.model';
import { TaskDetailsProductObject } from './tasks-details-product/task-details-product.model';
import { TaskScaiObject } from './tasks-details-scai/task-scai.model';
import { TaskPropertyObject } from '../tasks-properties/task-properties.model';
import { CharacteristicsObject } from '../../characteristics/characteristics.model';
import { isNullOrUndefined } from 'util';

export class TaskDetailsObject {

    private fetched: boolean;

    constructor(private product: TaskDetailsProductObject, private taskCharacteristics: CharacteristicsObject,
        private scai: TaskScaiObject, private comments: Array<TaskCommentObject>,
        private properties: TaskPropertyObject, fetched?: boolean) {
        this.fetched = isNullOrUndefined(fetched) ? true : fetched;
    }

    public static create(): TaskDetailsObject {
        return new TaskDetailsObject(TaskDetailsProductObject.create(),
            CharacteristicsObject.create(),
            TaskScaiObject.create(),
            new Array<TaskCommentObject>(),
            TaskPropertyObject.create(), false);
    }

    public getProduct(): TaskDetailsProductObject {
        return this.product;
    }

    public getTaskCharacteristics(): CharacteristicsObject {
        return this.taskCharacteristics;
    }

    public getScai(): TaskScaiObject {
        return this.scai;
    }

    public getComments(): Array<TaskCommentObject> {
        return this.comments;
    }

    public getProperties(): TaskPropertyObject {
        return this.properties;
    }

    public isFetched(): boolean {
        return this.fetched;
    }
}
